import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaBars,
  FaTimes,
  FaUsers,
  FaListAlt,
  FaVirus,
  FaBlog,
  FaHome,
  FaEnvelope,
} from "react-icons/fa";
import AppNavbar from "../AppNavbar";
import "./admin.css";

const AdminLayout = ({ children }) => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="admin-wrapper">

      {/* Global Navbar */}
      <AppNavbar />

      {/* Mobile overlay */}
      {open && <div className="admin-overlay" onClick={() => setOpen(false)} />}

      <div className="admin-container">

        {/* Sidebar */}
        <aside className={`admin-sidebar ${open ? "open" : ""}`}>
          <div className="admin-sidebar-header">
            <h4>Admin Paneli</h4>

            {/* Close only on mobile */}
            <button className="sidebar-close-btn mobile-only" onClick={() => setOpen(false)}>
              <FaTimes />
            </button>
          </div>

          <nav className="admin-menu">
            <Link
              to="/admin"
              className={location.pathname === "/admin" ? "active" : ""}
              onClick={() => setOpen(false)}
            >
              <FaHome /> Dashboard
            </Link>

            <Link
              to="/admin/users"
              className={location.pathname.includes("/admin/users") ? "active" : ""}
              onClick={() => setOpen(false)}
            >
              <FaUsers /> Kullanıcılar
            </Link>

            <Link
              to="/admin/formulas"
              className={location.pathname.includes("/admin/formulas") ? "active" : ""}
              onClick={() => setOpen(false)}
            >
              <FaListAlt /> Formüller
            </Link>

            <Link
              to="/admin/diseases"
              className={location.pathname.includes("/admin/diseases") ? "active" : ""}
              onClick={() => setOpen(false)}
            >
              <FaVirus /> Hastalıklar
            </Link>

            <Link
              to="/admin/blogs"
              className={location.pathname.includes("/admin/blogs") ? "active" : ""}
              onClick={() => setOpen(false)}
            >
              <FaBlog /> Blog Yönetimi
            </Link>

            {/* 🆕 YENİ EKLENDİ — İletişim Mesajları */}
            <Link
              to="/admin/contact-messages"
              className={location.pathname.includes("/admin/contact-messages") ? "active" : ""}
              onClick={() => setOpen(false)}
            >
              <FaEnvelope /> İletişim Mesajları
            </Link>
          </nav>
        </aside>

        {/* Mobile hamburger (AppNavbar ile çakışmaz) */}
        <button className="admin-hamburger mobile-only" onClick={() => setOpen(true)}>
          <FaBars size={22} />
        </button>

        {/* Content */}
        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
